import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IConsumoInternetRecord } from '@services/RelatorioService';
import React from 'react';

export type ConsumoInternetDetalhesTableProps = {
    data: IData<IConsumoInternetRecord>
}

export function ConsumoInternetDetalhesTable ({ data }: ConsumoInternetDetalhesTableProps) {
    const formatter = useFormatter();

    return (
        <TableNoResult itemCount={data.itemsCount}>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Competência</TableHeaderCell>
                    <TableHeaderCell>Número</TableHeaderCell>
                    <TableHeaderCell>Empresa</TableHeaderCell>
                    <TableHeaderCell>Operadora</TableHeaderCell>
                    <TableHeaderCell>Consumo</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                        data.items.map((consumoInternet, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{consumoInternet.linhaId}</TableKeyCell>
                                    <TableCell>{formatter.toCompetencia(consumoInternet.competencia)}</TableCell>
                                    <TableCell>{formatter.toCelular(consumoInternet.numeroSemMascara)}</TableCell>
                                    <TableCell>{consumoInternet.contratoOperadoraEmpresaNome}</TableCell>
                                    <TableCell>{consumoInternet.contratoOperadoraOperadoraNome}</TableCell>
                                    <TableCell>{formatter.toFloat(consumoInternet.consumo / 1024 / 1024)} GB</TableCell>
                                </TableRow>
                            )
                        })
                }
            </TableBody>
        </TableNoResult>
    )
}